// Import necessary React hooks and Redux functionality
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'; // For accessing Redux store and dispatching actions
import { loginUser, resetAuthError } from '../../auth/authActions'; // Adjust the path as necessary to import the loginUser action
import { Button, Form, Alert, Container, Row, Col } from 'react-bootstrap'; // Importing UI components from react-bootstrap
import SignupModal from './SignUp';
import Footer from './Footer';
import EmailWaitingListModal from './EmailWaitingListModal';

// The Login component
function Login() {
    const [showSignupModal, setShowSignupModal] = useState(false);
    // Local state for handling username and password inputs
    const [showWaitingListModal, setShowWaitingListModal] = useState(false);

    const [submitAttempted, setSubmitAttempted] = useState(false);
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');

    const isAuthenticated = useSelector((state) => state.auth.isAuthenticated); // Accessing the auth status
    const authError = useSelector((state) => state.auth.error); // Accessing the auth error from Redux state

    // useDispatch hook to dispatch actions, useSelector to access the current state
    const dispatch = useDispatch();
    const navigate = useNavigate(); //useNavigate to redirect after successful login

    useEffect(() => {
        if (isAuthenticated) {
            navigate('/dashboard'); // Redirect to Dashboard if authenticated
        }
    }, [isAuthenticated, navigate]);

    // Function to handle form submission
    const handleSubmit = (event) => {
        event.preventDefault(); // Prevent the form from refreshing the page
        setSubmitAttempted(true);
        console.log("Attempting to login", { username, password }); // Add logging to debug
        dispatch(loginUser(username, password)); // Dispatch the loginUser action with username and password
    };

    const handleShowModal = () => {
        setShowSignupModal(true); // Show the SignupModal
    };

    const handleClose = () => {
        setShowSignupModal(false); // Hide the modal
    };

    const handleInputChange = (setter) => (e) => {
        if (authError && submitAttempted) {
            dispatch(resetAuthError());
        }
        setter(e.target.value);
    };

    // Render the login form
    return (
        <div>
            <Container>
                <Row>
                    <Col xs={6} md={6} lg={6} xl={6} className="text-center content-style">
                        {/* Add an image here */}
                        <img src="https://images.pexels.com/photos/3225517/pexels-photo-3225517.jpeg" alt="Descriptive Alt Text" className="img-fluid" />
                    </Col>
                    <Col xs={6} md={6} lg={6} xl={6} className="content-style">
                        <Row>
                            <h1 className="mb-4 text-center">Login</h1>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group controlId="username" className="mb-3">
                                    <Form.Label>Username</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder="Enter username"
                                        value={username}
                                        onChange={handleInputChange(setUsername)}
                                    />
                                </Form.Group>

                                <Form.Group controlId="password" className="mb-3">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        placeholder="Password"
                                        value={password}
                                        onChange={handleInputChange(setPassword)}
                                    />
                                </Form.Group>

                                <div className="d-grid gap-2">
                                    <Button variant="primary" type="submit" className="mt-2">
                                        Let's go!
                                    </Button>
                                </div>
                            </Form>
                        </Row>
                        {submitAttempted && authError ? <Alert variant="danger" className="mt-3">{authError}</Alert> : null}
                        {isAuthenticated && <Alert variant="success" className="mt-3">Login Successful!</Alert>}
                        {/*
                        <Row className="justify-content-md-center align-items-center" style={{ minHeight: '100px' }}>
                            <Button variant="secondary"
                                className="custom-button"
                                onClick={() => setShowWaitingListModal(true)}
                                style={{
                                    marginTop: '20px',
                                    backgroundColor: '#4B88A2',
                                    padding: '8px 12px', // Smaller padding
                                    fontSize: '16px', // Smaller font size
                                    boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
                                    maxWidth: '400px',
                                }}>
                                <i className="bi bi-envelope-fill" style={{ marginRight: '8px' }}></i>
                                Join our waiting list
                            </Button>
                        </Row>
                        */}
                        <Row className="justify-content-md-center">
                            <Col xs={12} md={6} className="text-center mt-3">
                                <Button variant="outline-secondary" onClick={handleShowModal}>
                                    Don't have an account yet?
                                    <br />
                                    <strong>Sign Up</strong>
                                </Button>
                            </Col>
                        </Row>

                    </Col>
                </Row>
                <SignupModal
                    show={showSignupModal}
                    handleClose={handleClose}
                />
                <EmailWaitingListModal
                    show={showWaitingListModal}
                    onHide={() => setShowWaitingListModal(false)}
                />
            </Container>
            <Footer /> {/* Common Footer component */}
        </div>
    );
}

export default Login;